/* eslint-disable */
import React, { useState, useCallback, useEffect, useRef } from 'react';
import type { FC } from 'react';
import {Alert, Box, CircularProgress, Collapse, Container, Grid, IconButton, Typography} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import {
  BarDonutInfo,
  CashhAvaiblePerDay,
} from 'src/components/dashboard/overview/masterOverview';
import ArrowDown from 'src/icons/ArrowDown';
import ArrowUp from 'src/icons/ArrowUp';
import useIndicators from 'src/hooks/useIndicators';
import useAuth from 'src/hooks/useAuth';
import useIsMountedRef from '../../hooks/useIsMountedRef';
import { IdleTimerProvider } from 'react-idle-timer';
import DatePicker, {registerLocale} from "react-datepicker";
import es from "date-fns/locale/es";
registerLocale("es",es);
import { useStyles } from 'src/components/dashboard/style';
import 'react-datepicker/dist/react-datepicker.css'
import ChartCapitalDeTrabajo from 'src/components/dashboard/overview/masterOverview/Charts/ChartCapitalDeTrabajo';
import VentasVsCostosPorMes from 'src/components/dashboard/overview/masterOverview/Charts/VentasVsCostosPorMes';
import TablaPrior from 'src/components/dashboard/overview/masterOverview/Tablas/TablaPrior';
import ChartCambiosCapitalTrabajo from 'src/components/dashboard/overview/masterOverview/Charts/ChartCambiosCapitalTrabajo';
import ChartIndiceCrecimiento from 'src/components/dashboard/overview/masterOverview/Charts/ChartIndiceCrecimiento';
import IndicesSolvencia from 'src/components/dashboard/overview/masterOverview/Charts/IndicesSolvencia';
import IndicesOperacionales from 'src/components/dashboard/overview/masterOverview/Charts/IndicesOperacionales';
import IndicesLiquidez from 'src/components/dashboard/overview/masterOverview/Charts/IndicesLiquidez';
import IndicesApalancamiento from 'src/components/dashboard/overview/masterOverview/Charts/IndicesApalancamiento';
import IndicesRentabilidad from 'src/components/dashboard/overview/masterOverview/Charts/IndicesRentabilidad';
import BarDonutOpIF from "../../components/dashboard/overview/masterOverview/Charts/BarDonutOpIF";
import BarDonutIF from "../../components/dashboard/overview/masterOverview/Charts/BarDonutIF";
import ChartLineZoom from "../../components/dashboard/overview/masterOverview/Charts/ChartLineZoom";
import {getZazacorpPrediction} from "../../components/bridges/BridgeBusiness";
import {addDays} from "date-fns";
import data from "../../icons/Data";
import TrendingUpIcon from "@material-ui/icons/TrendingUp";
import solvenciaIcon from "../../assets/icons/solvenciaIcon.svg";
import liquidezIcon from "../../assets/icons/liquidezIcon.svg";
import apalancamientoIcon from "../../assets/icons/apalancamientoIcon.svg";
import rentabilidadIcon from "../../assets/icons/rentabilidadIcon.svg";

const OverviewIndicadoresFinancieros: FC = () => {
  const classes = useStyles();
  const { getDashboardMaster, dashboardMaster, getTradeByBusiness } =
    useIndicators();
  const isMountedRef = useIsMountedRef();
  const { user } = useAuth();
  const [info, setInfo] = useState<any>();
  const { t } = useTranslation('dashboard');
  const date = new Date();
  let nextDate = new Date(date)
  nextDate.setFullYear(date.getFullYear() +1)
  const utc = date.getTime() + date.getTimezoneOffset() * 60000;
  const nd = new Date(utc + 3600000 * -5);
  const now = `${nd.getFullYear()}-${nd.getMonth() + 1}-${nd.getDate()}`;
  const topRef = useRef(null);
  const bottomRef = useRef(null);
  const [goingUp, setGoingUp] = useState(false);
  const [currentIndiceSolvencia, setCurrentIndiceSolvencia] = useState('Capital Accionario/ Deuda');
  const [currentIndiceLiquidez, setCurrentIndiceLiquidez] = useState('Índice Corriente');
  const [currentIndiceApalancamiento, setCurrentIndiceApalancamiento] = useState('Índice de deuda');
  const [currentIndiceRentabilidad, setCurrentIndiceRentabilidad] = useState('Margen de Rentabilidad Bruta');
  const [serieOperacional, setSerieOperacional] = useState({crecimiento: 0, retorno: 0, cicloDeConversion: 0});
  const [serieSolvenvia, setSerieSolvencia] = useState({estructuraCapital: 0, rotacion: 0});
  const [serieLiquidez, setSerieLiquidez] = useState({corriente: 0, acidTest: 0, capitalTrabajo: 0});
  const [serieApalancamiento, setSerieApalancamiento] = useState({deuda: 0, apalancamiento: 0, accionario: 0});
  const [serieRentabilidad, setSerieRentabilidad] = useState({rentabilidadBruta: 0, retornoCapital: 0, roa: 0});
  const [graphEstructuraCapital, setGraphEstructuraCapital] = useState([]);
  const [graphRotacion, setGraphRotacion] = useState([]);
  const [graphCorriente, setGraphCorriente] = useState([]);
  const [graphAcidTest, setGraphAcidTest] = useState([]);
  const [graphCapitalTrabajo, setGraphCapitalTrabajo] = useState([]);
  const [graphDeuda, setGraphDeuda] = useState([]);
  const [graphApalancamiento, setGraphApalancamiento] = useState([]);
  const [graphAccionario, setGraphAccionario] = useState([]);
  const [graphRentabilidadBruta, setGraphRentabilidadBruta] = useState([]);
  const [graphRetornoCapital, setGraphRetornoCapital] = useState([]);
  const [graphRoa, setGraphRoa] = useState([]);
  const [isLoading, setIsLoading] = useState(false)
  const prevScrollY = useRef(
    topRef.current !== null &&
      topRef.current.getBoundingClientRect() !== undefined
      ? topRef.current.getBoundingClientRect().y
      : 0
  );


  let today = new Date()

  const [valueDate, setvalueDate] = useState(today);

  const executeScroll = () => {
    if (goingUp) {
      if (topRef.current === null) return;
      topRef.current.scrollIntoView();
      setGoingUp(false);
    } else if (!goingUp) {
      if (bottomRef.current === null) return;
      bottomRef.current.scrollIntoView();
      setGoingUp(true);
    }
  };

  const handleScroll = () => {
    if (topRef.current === null) return;
    const currentScrollY = topRef.current.getBoundingClientRect().y;
    if (prevScrollY.current < currentScrollY && goingUp) {
      setGoingUp(false);
    }
    if (prevScrollY.current > currentScrollY && !goingUp) {
      setGoingUp(true);
    }
    prevScrollY.current = currentScrollY;
  };

  const EtlStatus = async () => {
    try {
      if (user['rolDesc'] === 'master' || user['rolDesc'] === 'estandar') {
        const obj = {
          businessId: user.businessId.business_id,
          date: now,
        };
        await getDashboardMaster();
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    EtlStatus();
  }, []);

  useEffect(() => {
    setInfo(dashboardMaster);
  }, [dashboardMaster]);

  useEffect(() => {
    window.addEventListener('wheel', handleScroll);

    return () => window.removeEventListener('wheel', handleScroll);
  }, [goingUp]);

  const onIdle = () => {
    window.location.reload();
  };

  const handleOnDateChange = (date: any) => {
    setvalueDate(date);
  }

  const handleIndiceSolvencia = (indicator) => {
    setCurrentIndiceSolvencia(indicator);
  }

  const handleIndiceLiquidez = (indicator) => {
    setCurrentIndiceLiquidez(indicator);
  }

  const handleIndiceApalancamiento = (indicator) => {
    setCurrentIndiceApalancamiento(indicator);
  }

  const handleIndiceRentabilidad = (indicator) => {
    setCurrentIndiceRentabilidad(indicator);
  }

  const valueTodayDate = new Date()
  const yearToday = valueTodayDate.getFullYear();
  const monthToday = String(valueTodayDate.getMonth() + 1).padStart(2, '0');
  const dayToday = String(valueTodayDate.getDate()).padStart(2, '0');
  const formattedDateToday = `${yearToday}-${monthToday}-${dayToday}`;



  const year = valueDate.getFullYear();
  const month = String(valueDate.getMonth() + 1).padStart(2, '0');
  const day = String(valueDate.getDate()).padStart(2, '0');
  const formattedDate = `${year}-${month}-${day}`;



  const dataOperacional = [
    {
      indicador: "Índice de Crecimiento (Ventas)",
      definition: "El índice de crecimiento en ventas indica qué tan rápido está creciendo una empresa o su negocio. " +
          "El crecimiento de las ventas netas (%) considera las ventas totales de una organización menos las " +
          "devoluciones, los descuentos, etc.",
      series: formattedDate === formattedDateToday ? [0] : [serieOperacional.crecimiento],
      type: "percentage"
    },
    {
      indicador: "Retorno del Inventario (GMROI)",
      definition: "El rendimiento del margen bruto sobre la inversión en inventario es una relación que expresa el " +
          "rendimiento de cada unidad monetaria gastada en inventario. El GMROI (GROSS MARGIN RETURN ON INVESTMENT) responde a la pregunta " +
          "\"por cada unidad de inventario promedio mantenida al costo, ¿cuántas unidades monetarias de ganancia " +
          "bruta generé en un año?\". ",
      series: [serieOperacional.retorno],
      type: "number",
    },
    {
      indicador: "Ciclo de Conversión de Efectivo (CCE)",
      definition: "El ciclo de conversión de efectivo es una métrica que expresa, en días, cuánto tiempo le toma a una " +
          "empresa convertir el efectivo gastado en inventario proveniente de la venta de su producto o servicio. Cuanto" +
          " más corto sea el ciclo del efectivo, mejor, ya que indica menos tiempo que el efectivo está vinculado a las " +
          "cuentas por cobrar o al inventario. ",
      series: [serieOperacional.cicloDeConversion],
      type: "number",
    }
  ];

  const dataSolvencia = [
    {
      indice: 'Estructura de Capital',
      definition: "La relación capital-deuda es una relación financiera que indica la proporción relativa del capital " +
          "contable y la deuda utilizada para financiar los activos de una empresa. Si la ratio es mayor a 1, eso" +
          " indica que la estructura para financiera los activos de la empresa provienen más del capital de la empresa." +
          " Cuando el ratio es menor a 1, el financiamiento tiene más peso por el lado de la deuda de la empresa, " +
          "principalmente obligaciones financieras a corto y largo plazo.",
      series: [serieSolvenvia.estructuraCapital],
      type: "number",
    },
    {
      indice: 'Rotación de Activos',
      definition: "La rotación de activos mide la eficiencia del uso de los activos para generar ingresos por ventas para" +
          " la empresa. Las empresas con bajos márgenes de utilidad tienden a tener una alta rotación de activos," +
          " mientras que aquellas con altos márgenes de utilidad tienen una baja rotación de activos.",
      series: [serieSolvenvia.rotacion],
      type: "percentage",
    }
  ];

  const dataLiquidez = [
    {
      indice: 'Índice Corriente',
      definition: "El índice corriente o circulante mide si una empresa tiene recursos suficientes para cumplir con sus " +
          "obligaciones a corto plazo. Compara los activos corrientes de una empresa con sus pasivos corrientes. Si el" +
          " índice es superior a 1, eso indica que la empresa cuenta con suficientes activos a corto plazo para cumplir " +
          "con sus obligaciones corrientes. Sin embargo, si este número es muy alto podría interpretarse como que la " +
          "compañía o empresa no está aprovechando sus activos corrientes para generar mayor productividad o rentabilidad.",
      series: [serieLiquidez.corriente],
      type: "number",
    },
    {
      indice: 'Acid Test',
      definition: "El índice de prueba ácida es un índice de liquidez que mide qué tan suficientes son los activos a " +
          "corto plazo de una empresa para cubrir sus pasivos corrientes. Es decir, excluyendo el " +
          "inventario este índice explica el grado en que los activos de mayor conversión a efectivo pueden hacer o no" +
          " frente a las obligaciones de corto plazo de la empresa.",
      series: [serieLiquidez.acidTest],
      type: "number",
    },
    {
      indice: 'Capital de Trabajo',
      definition: "El capital de trabajo es una métrica financiera que representa la liquidez operativa disponible para" +
          " una empresa. Específicamente, la gestión del capital de trabajo implica la gestión de inventarios, cuentas" +
          " por cobrar y por pagar y efectivo. Si los activos circulantes son menores que los pasivos circulantes, " +
          "una entidad tiene un déficit de capital de trabajo.",
      series: [serieLiquidez.capitalTrabajo],
      type: "money",

    }
  ];

  const dataApalancamiento = [
    {
      indice: 'Índice de deuda',
      definition: "El índice de endeudamiento es un índice financiero que indica el porcentaje de los activos de una " +
          "empresa que se obtienen a través de deuda (proveniente tanto de proveedores como de instituciones financieras)." +
          " Es la relación entre la deuda total (pasivos a corto y largo plazo) y los activos totales (la suma de los " +
          "activos corrientes y no corrientes). Por ejemplo, una empresa con 2 millones de dólares en activos totales " +
          "y 500.000 dólares en pasivos totales tendría un índice de endeudamiento del 25%. Si el ratio es inferior a" +
          " 0,5, la mayoría de los activos de la empresa se financian mediante capital. Si el ratio es superior a 0,5, " +
          "la mayor parte de los activos de la empresa se financian mediante deuda. Cuanto mayor sea el índice, mayor " +
          "será el riesgo asociado con la operación de la empresa. ",
      series: [serieApalancamiento.deuda],
      type: "number",
    },
    {
      indice: 'Índice de Apalancamiento',
      definition: "Un índice de apalancamiento es cualquiera de varias medidas financieras que analizan cuánto capital " +
          "viene en forma de deuda (préstamos). La categoría del índice de apalancamiento es importante porque las" +
          " empresas dependen de una combinación de capital y deuda para financiar sus operaciones, y conocer la" +
          " cantidad de deuda que tiene una empresa es útil para evaluar si puede pagar sus deudas a su vencimiento.",
      series: [serieApalancamiento.apalancamiento],
      type: "number",
    },
    {
      indice: 'Apalancamiento Accionario',
      definition: "El apalancamiento accionario determina la relación que existe entre los pasivos totales y el capital" +
          " de la empresa. Si el ratio es mayor a 1, eso indica que la estructura para financiera los activos de la" +
          " empresa provienen más de los pasivos. Cuando el ratio es menor a 1, el financiamiento tiene más peso por el" +
          " lado del capital de la empresa. ",
      series: [serieApalancamiento.accionario],
      type: "number",
    }
  ];

  const dataRentabilidad = [
    {
      indice: 'Margen de Rentabilidad Bruta',
      definition: "El margen de rentabilidad bruta es la diferencia que existe entre los ingresos y el costo de los " +
          "bienes vendidos (COGS: COST OF GOODS SOLD), dividido por los ingresos. En general, se calcula como el precio" +
          " de venta de un artículo, menos el costo de los bienes vendidos (por ejemplo, costos de producción o " +
          "adquisición, sin incluir gastos fijos o variables). ",
      series: [serieRentabilidad.rentabilidadBruta],
      type: "percentage",
    },
    {
      indice: 'Retorno de Capital',
      definition: "El retorno de capital es una relación utilizada en finanzas, valoración y contabilidad, como una " +
          "medida de la rentabilidad y la potencial creación de valor de las empresas en relación con el monto de " +
          "capital invertido por los accionistas. Indica cuán efectiva es una empresa para convertir el capital en ganancias.",
      series: [serieRentabilidad.retornoCapital],
      type: "percentage",
    },
    {
      indice: 'Retorno de Activo (ROA)',
      definition: "El retorno de los activos (ROA: RETURN ON ASSETS) muestra el porcentaje de cuán rentables son los activos de una empresa" +
          " para generar ingresos. Este número le dice lo que la compañía puede hacer con lo que tiene, es decir," +
          " cuántos dólares de ganancias obtienen de cada dólar de activos que controlan. Las empresas que requieren " +
          "grandes inversiones iniciales generalmente tendrán un menor rendimiento de los activos. Los ROA de más del" +
          " 5% generalmente se consideran buenos.  ",
      series: [serieRentabilidad.roa],
      type: "percentage",
    }
  ];

  const buildGraph = async (data) => {
    const fechaBase = new Date(valueDate);
    const length = data.header.length;
    let datesArray = [];
    let tempDataEstructuraCapital = [];
    let tempDataRotacion = [];
    let tempDataCorriente = [];
    let tempDataAcidTest = [];
    let tempDataCapitalTrabajo = [];
    let tempDataDeuda = [];
    let tempDataApalancamiento = [];
    let tempDataAccionado = [];
    let tempDataRentabilidadBruta = [];
    let tempDataRetornoCapital = [];
    let tempDataRoa = [];
    for (let i = 0; i < length; i++) {
      let futureDate = new Date(fechaBase.getFullYear(), fechaBase.getMonth(), fechaBase.getDate() + i);
      datesArray.push(futureDate.getTime()); // No division by 1000, to get milliseconds
    }
    console.log("data.rows", data.rows)
    await Promise.all(data.rows.map( async (row) => {
      if (row.data[0] === "Indices de Solvencia") {
        row.subRows.map(async (subRow) => {
          if (subRow.data[0] === "Capital accionario/deuda") {
            const [, ...restOfData] = subRow.data;
            datesArray.map((date,index) => {
              const tempDateData = [date, restOfData[index]];
              tempDataEstructuraCapital.push(tempDateData);
            })
            setGraphEstructuraCapital(tempDataEstructuraCapital);
          }
          
        })
      }
      if (row.data[0] === "Indices de Liquidez") {
        row.subRows.map(async (subRow) => {
          if (subRow.data[0] === "Indice Corriente (activos corrientes/pasivos corrientes)") {
            const [, ...restOfData] = subRow.data;
            datesArray.map((date,index) => {
              const tempDateData = [date, restOfData[index]];
              tempDataCorriente.push(tempDateData);
            })
            setGraphCorriente(tempDataCorriente);
          }
          if (subRow.data[0] === "Acit test ((activos corrientes - inventario)/pasivos corrientes)") {
            const [, ...restOfData] = subRow.data;
            datesArray.map((date,index) => {
              const tempDateData = [date, restOfData[index]];
              tempDataAcidTest.push(tempDateData);
            })
            setGraphAcidTest(tempDataAcidTest);
          }
          if (subRow.data[0] === "Capital de Trabajo (activos corrientes - pasivos corrientes)") {
            const [, ...restOfData] = subRow.data;
            datesArray.map((date,index) => {
              const tempDateData = [date, restOfData[index]];
              tempDataCapitalTrabajo.push(tempDateData);
            })
            setGraphCapitalTrabajo(tempDataCapitalTrabajo);
          }
        })
      }
      if (row.data[0] === "Indices de Apalancamiento") {
        row.subRows.map(async (subRow) => {
          if (subRow.data[0] === "Indice de Deuda (pasivos totales/activos totales)") {
            const [, ...restOfData] = subRow.data;
            datesArray.map((date,index) => {
              const tempDateData = [date, restOfData[index]];
              tempDataDeuda.push(tempDateData);
            })
            setGraphDeuda(tempDataDeuda);
          }
          if (subRow.data[0] === "Apalancamiento (deuda/capital)") {
            const [, ...restOfData] = subRow.data;
            datesArray.map((date,index) => {
              const tempDateData = [date, restOfData[index]];
              tempDataApalancamiento.push(tempDateData);
            })
            setGraphApalancamiento(tempDataApalancamiento);
          }
          if (subRow.data[0] === "Apalancamiento Accionario (pasivos totales/capital accionario)") {
            const [, ...restOfData] = subRow.data;
            datesArray.map((date,index) => {
              const tempDateData = [date, restOfData[index]];
              tempDataAccionado.push(tempDateData);
            })
            setGraphAccionario(tempDataAccionado);
          }
        })
      }
      if (row.data[0] === "Indices de Rentabilidad") {
        row.subRows.map(async (subRow) => {
          if (subRow.data[0] === "Margen de Rentabilidad Bruta (utilidad bruta/ventas)") {
            const [, ...restOfData] = subRow.data;
            datesArray.map((date,index) => {
              const tempDateData = [date, restOfData[index]];
              tempDataRentabilidadBruta.push(tempDateData);
            })
            setGraphRentabilidadBruta(tempDataRentabilidadBruta);
          }
          if (subRow.data[0] === "Retorno del Capital (1)*(2)*(3)") {
            const [, ...restOfData] = subRow.data;
            datesArray.map((date,index) => {
              const tempDateData = [date, restOfData[index]];
              tempDataRetornoCapital.push(tempDateData);
            })
            setGraphRetornoCapital(tempDataRetornoCapital);
          }
          if (subRow.data[0] === "Retorno de Activos (ROA) (utilidad neta/total activos))") {
            const [, ...restOfData] = subRow.data;
            datesArray.map((date,index) => {
              const tempDateData = [date, restOfData[index]];
              tempDataRoa.push(tempDateData);
            })
            setGraphRoa(tempDataRoa);
          }
        })
      }
      if (row.data[0] === "Indices Operacionales") {
        row.subRows.map(async (subRow) => {
          if (subRow.data[0] === "Rotacion de Activos (ventas/activos totales)") {
            const [, ...restOfData] = subRow.data;
            datesArray.map((date,index) => {
              const tempDateData = [date, restOfData[index]];
              tempDataRotacion.push(tempDateData);
            })
            setGraphRotacion(tempDataRotacion);
          }
        })
      }
    }))
  }

  const buildZazacorpTableJson = async (data) => {
    // Identificar todos los encabezados de fecha únicos en los datos
    let headerDates = [];
    data.forEach(item => {
      Object.keys(item).forEach(key => {
        const parts = key.split('_');
        if (parts.length === 2 && !isNaN(Number(parts[1]))) {
          if (!headerDates.includes(key)) {
            headerDates.push(key);
          }
        }
      });
    });
    // headerDates.sort(); // Para ordenar las fechas

    // Transformar las claves de fecha en fechas formateadas
    // const fechaBase = new Date(data[0].fecha_desde);
    const fechaBase = new Date(valueDate);
    let currentDate = fechaBase;
    const formattedDates = headerDates.map((date, index) => {
      if (index === 0) {
        return "Hoy"; // Primer encabezado como 'Today'
      }
      const day = parseInt(date.split('_')[1], 10);
      const newDate = addDays(currentDate, 1);
      currentDate = newDate;
      return `${newDate.getDate().toString().padStart(2, '0')}/${(newDate.getMonth() + 1).toString().padStart(2, '0')}/${newDate.getFullYear()}`;
    });


    // Crear un mapa para mantener referencias a las filas basadas en índices
    const indexToRowMap = new Map();

    // Crear la estructura de filas y subfilas
    const rows = [];

      console.log("data", data)


    data.forEach(item => {
      const rowData = [item.name, ...headerDates.map(date => item[date] === null ? 0 : item[date])];

      const indexParts = item.index.split('.');
      const row = { data: rowData, subRows: [] };
      indexToRowMap.set(item.index, row);

      if (indexParts.length === 1) {
        // Es una categoría principal
        rows.push(row);
      } else {
        // console.log("index", item.index)
        // console.log("row", row)
        if(row.data[0] === 'Capital accionario/deuda'){
            console.log("subcategory", row)
            const parentIndex = indexParts.slice(0, -1).join('.');
            console.log("parentIdx", parentIndex)
            console.log("foundidx", indexToRowMap.get(parentIndex))
        }
        // Es una subcategoría
        const parentIndex = indexParts.slice(0, -1).join('.');
        const parentRow = indexToRowMap.get(parentIndex);
        if (parentRow) {
          parentRow.subRows.push(row);
        }
      }
    });

    console.log("indexMap", indexToRowMap)

    return {header: formattedDates, rows};
  };

  async function getPredictions() {
    try {
      setIsLoading(true)

      console.log("valueDate", valueDate)

      const year = valueDate.getFullYear();
      const month = String(valueDate.getMonth() + 1).padStart(2, '0');
      const day = String(valueDate.getDate()).padStart(2, '0');
      const formattedDate = `${year}-${month}-${day}`;

      console.log("formattedDate", formattedDate)
      const response = await getZazacorpPrediction(formattedDate,formattedDate,'if_predict');
      const tableJson = await buildZazacorpTableJson(response.resultRangeDates);
      console.log("tableJson", tableJson)
      const tableEndYearJson = await buildZazacorpTableJson(response.resultUntilEndYear);
      console.log("tableEndYear", tableEndYearJson)
      await buildGraph(tableEndYearJson);
      const operacionales = tableJson.rows.filter(row => row.data[0] === "Indices Operacionales")[0].subRows;
      const solvencia = tableJson.rows.filter(row => row.data[0] === "Indices de Solvencia")[0].subRows;
      const liquidez = tableJson.rows.filter(row => row.data[0] === "Indices de Liquidez")[0].subRows;
      const apalancamiento = tableJson.rows.filter(row => row.data[0] === "Indices de Apalancamiento")[0].subRows;
      const rentabilidad = tableJson.rows.filter(row => row.data[0] === "Indices de Rentabilidad")[0].subRows;
      const gmroiBreakup = tableJson.rows.filter(row => row.data[0] === "GRMROI break-up")[0].subRows;
      const crecimiento = tableJson.rows.filter(row => row.data[0] === "Indice de Crecimiento")[0]
      console.log("crecimiento", crecimiento)

      const tempOperacional = {
        crecimiento: parseFloat(( crecimiento.data[1] * 100).toFixed(2)),
        retorno: parseFloat((gmroiBreakup.filter(row => row.data[0] === "GMROI (1)*(2)*(3)")[0].data[1]).toFixed(2)),
        cicloDeConversion: parseFloat((operacionales.filter(row => row.data[0] === "CCE (1)+(2)-(3)")[0].data[1]).toFixed(2)),
      };
      const tempSolvencia = {
        estructuraCapital: parseFloat((solvencia.filter(row => row.data[0] === "Capital accionario/deuda")[0].data[1]).toFixed(2)),
        rotacion: parseFloat((operacionales.filter(row => row.data[0] === "Rotacion de Activos (ventas/activos totales)")[0].data[1] * 100).toFixed(2)),
      };
      const tempLiquidez = {
        corriente: parseFloat((liquidez.filter(row => row.data[0] === "Indice Corriente (activos corrientes/pasivos corrientes)")[0].data[1]).toFixed(2)),
        acidTest: parseFloat((liquidez.filter(row => row.data[0] === "Acit test ((activos corrientes - inventario)/pasivos corrientes)")[0].data[1]).toFixed(2)),
        capitalTrabajo: parseFloat((liquidez.filter(row => row.data[0] === "Capital de Trabajo (activos corrientes - pasivos corrientes)")[0].data[1]).toFixed(2)),
      };
      const tempApalancamiento = {
        deuda: parseFloat((apalancamiento.filter(row => row.data[0] === "Indice de Deuda (pasivos totales/activos totales)")[0].data[1]).toFixed(2)),
        apalancamiento: parseFloat((apalancamiento.filter(row => row.data[0] === "Apalancamiento (deuda/capital)")[0].data[1]).toFixed(2)),
        accionario: parseFloat((apalancamiento.filter(row => row.data[0] === "Apalancamiento Accionario (pasivos totales/capital accionario)")[0].data[1]).toFixed(2)),
      };
      const tempRentabilidad = {
        rentabilidadBruta: parseFloat((rentabilidad.filter(row => row.data[0] === "Margen de Rentabilidad Bruta (utilidad bruta/ventas)")[0].data[1] * 100).toFixed(2)),
        retornoCapital: parseFloat((rentabilidad.filter(row => row.data[0] === "Retorno del Capital (1)*(2)*(3)")[0].data[1] * 100).toFixed(2)),
        roa: parseFloat((rentabilidad.filter(row => row.data[0] === "Retorno de Activos (ROA) (utilidad neta/total activos))")[0].data[1] * 100).toFixed(2)),
      };
      console.log("tempRentabilidad", tempRentabilidad)

      setSerieOperacional(tempOperacional);
      setSerieSolvencia(tempSolvencia);
      setSerieLiquidez(tempLiquidez);
      setSerieApalancamiento(tempApalancamiento);
      setSerieRentabilidad(tempRentabilidad);
      setIsLoading(false)
    } catch (e) {
      console.log(e);
    }
  }

  const capChart = {
    id: 1,
    name: 'Estructura de Capital',
    series: graphEstructuraCapital.slice(0,-2),
    valType: "number"
  }

  const rotChart = {
    id: 2,
    name: 'Rotación de Activos',
    series: graphRotacion.slice(0,-2),
    valType: "percentage"
  }
  const indCorChart = {
    id: 3,
    name: 'Índice Corriente',
    series: graphCorriente.slice(0,-2),
    valType: "number"
  }

  const acidChart = {
    id: 4,
    name: 'Acid Test',
    series: graphAcidTest.slice(0,-2),
    valType: "number"
  }
  const capTraChart = {
    id: 5,
    name: 'Capital de Trabajo',
    series: graphCapitalTrabajo.slice(0,-2),
    valType: "money",
  }
  const inDeuChart = {
    id: 6,
    name: 'Índice de deuda',
    series: graphDeuda.slice(0,-2),
    valType: "number"
  }
  const inApaChart = {
    id: 7,
    name: 'Índice de Apalancamiento',
    series: graphApalancamiento.slice(0,-2),
    valType: "number",
  }
  const apaChart = {
    id: 8,
    name: 'Apalancamiento Accionario',
    series: graphAccionario.slice(0,-2),
    valType: "number",
  }
  const marChart = {
    id: 9,
    name: 'Margen de Rentabilidad Bruta',
    series: graphRentabilidadBruta.slice(0,-2),
    valType: "percentage",
  }
  const reChart = {
    id: 10,
    name: 'Retorno de Capital',
    series: graphRetornoCapital.slice(0,-2),
    valType: "percentage",
  }
  const roaChart = {
    id: 11,
    name: 'Retorno de Activo (ROA)',
    series: graphRoa.slice(0,-2),
    valType: "percentage",
  }

  useEffect(() => {
    getPredictions();
  }, [valueDate]);

  return (
    <div>
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      minHeight: "100vh",
      backgroundColor: "background.default",
    }}
  >
    <Container maxWidth={false} sx={{ flexGrow: 1, display: "flex", flexDirection: "column" }}>
      <Box sx={{ flexGrow: 1, paddingTop: 2 }}>
        <Grid container justifyContent="space-between" spacing={3}>
          <Grid item xs={2} md={10} display="flex" alignItems="center" sx={{ paddingTop: '7px' }}>
            <TrendingUpIcon sx={{ color: '#001930' }} fontSize="medium" />
            <Typography
              sx={{
                paddingLeft: 1,
                fontWeight: 700,
                fontSize: '1.825rem',
              }}
              color="textSecondary"
            >
              Indicadores Financieros Proforma
            </Typography>
          </Grid>

          <Grid item xs={12} md={2} display="flex" alignItems="center">
            <Typography color="#42526E" fontWeight={500} mr={1} display="flex">Fecha</Typography>
            <DatePicker
              minDate={new Date()}
              maxDate={nextDate}
              selected={valueDate}
              locale="es"
              onChange={handleOnDateChange}
              dateFormat="yyyy-MM-dd"
              className={classes.datePicker}
            />
          </Grid>

          {isLoading ? (
            <Grid item xs={12} md={12} pt={10} display="flex" justifyContent="center">
              <CircularProgress />
            </Grid>
          ) : (
            <>
              <Grid container spacing={2} mt={1}>
                <Grid item xs={12}>
                  <BarDonutOpIF info={dataOperacional} />
                </Grid>

                {/* Solvencia Section */}
                <Grid item xs={12} mt={1} ml={2} p={1} sx={{ backgroundColor: "white", borderRadius: "15px" }}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} display="flex" alignItems="center" justifyContent="center">
                      <Box mr={1}>
                        <img src={solvenciaIcon} alt="solvenciaIcon" width="35px" height="35px" />
                      </Box>
                      <Typography className={classes.chartBarDonutTitle}>Solvencia</Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <BarDonutIF info={dataSolvencia} indicador="Solvencia" selectedIndice={handleIndiceSolvencia} />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <ChartLineZoom data={info} props={currentIndiceSolvencia === 'Rotación de Activos' ? rotChart : capChart} />
                    </Grid>
                  </Grid>
                </Grid>

                {/* Liquidez Section */}
                <Grid item xs={12} mt={1} ml={2} p={1} sx={{ backgroundColor: "white", borderRadius: "15px" }}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} display="flex" alignItems="center" justifyContent="center">
                      <Box mr={1}>
                        <img src={liquidezIcon} alt="liquidezIcon" width="35px" height="35px" />
                      </Box>
                      <Typography className={classes.chartBarDonutTitle}>Liquidez</Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <BarDonutIF info={dataLiquidez} indicador="Liquidez" selectedIndice={handleIndiceLiquidez} />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <ChartLineZoom data={info} props={currentIndiceLiquidez === 'Acid Test' ? acidChart : currentIndiceLiquidez === 'Capital de Trabajo' ? capTraChart : indCorChart} />
                    </Grid>
                  </Grid>
                </Grid>

                {/* Apalancamiento Section */}
                <Grid item xs={12} mt={1} ml={2} p={1} sx={{ backgroundColor: "white", borderRadius: "15px" }}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} display="flex" alignItems="center" justifyContent="center">
                      <Box mr={1}>
                        <img src={apalancamientoIcon} alt="apalancamientoIcon" width="35px" height="35px" />
                      </Box>
                      <Typography className={classes.chartBarDonutTitle}>Apalancamiento</Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <BarDonutIF info={dataApalancamiento} indicador="Apalancamiento" selectedIndice={handleIndiceApalancamiento} />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <ChartLineZoom data={info} props={currentIndiceApalancamiento === 'Índice de deuda' ? inDeuChart : currentIndiceApalancamiento === 'Apalancamiento Accionario' ? apaChart : inApaChart} />
                    </Grid>
                  </Grid>
                </Grid>

                {/* Rentabilidad Section */}
                <Grid item xs={12} mt={1} ml={2} p={1} sx={{ backgroundColor: "white", borderRadius: "15px" }}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} display="flex" alignItems="center" justifyContent="center">
                      <Box mr={1}>
                        <img src={rentabilidadIcon} alt="rentabilidadIcon" width="35px" height="35px" />
                      </Box>
                      <Typography className={classes.chartBarDonutTitle}>Rentabilidad</Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <BarDonutIF info={dataRentabilidad} indicador="Rentabilidad" selectedIndice={handleIndiceRentabilidad} />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <ChartLineZoom data={info} props={currentIndiceRentabilidad === 'Retorno de Capital' ? reChart : currentIndiceRentabilidad === 'Retorno de Activo (ROA)' ? roaChart : marChart} />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </>
          )}
        </Grid>
      </Box>

      {/* Footer */}
      <Box component="footer" sx={{ py: 2 }}>
        <Typography  sx={{ fontSize: '1rem' }}>© 2025 Dynamics Within. Todos los Derechos Reservados.</Typography>
      </Box>
    </Container>
  </Box>
</div>
  );
};

export default OverviewIndicadoresFinancieros;
